// Copyright: IQGeo Limited 2010-2019
import myw from 'myWorld-base';

myw.PrintPlugin = myw.Plugin.extend({
    /**
     * @class Print functionality to the application <br/>
     * Adds a button to the toolbar to access the print preview page
     * @param  {Application} owner                       The application
     * @constructs
     * @extends {Plugin}
     */
    initialize(owner) {
        myw.Plugin.prototype.initialize.call(this, owner);
    },
    /**
     * Opens a new window in a new tab passing url parameters
     * @private
     */
    openPrintWindow() {
        let url = `${this.app.name}.html`;
        const urlParams = this.app.getUrlQueryString();
        this.app.saveState(); //Save state to persist delta in print view

        //store sesion variables in local storage to avoid trying to pass them in the url as it go over limit
        localStorage.setItem('sessionVars', JSON.stringify(this.app.database.getSessionVars()));

        url = `${url}?${urlParams}&layout=print`;

        window.open(url, '_blank');
    }
});

myw.PrintPlugin.prototype.buttons = {
    dialog: myw.PluginButton.extend({
        titleMsg: 'toolbar_msg',
        imgSrc: 'images/toolbar/print.svg',
        action() {
            this.app.recordFunctionalityAccess('core.toolbar.print');
            this.owner.openPrintWindow();
        }
    })
};

export default myw.PrintPlugin;
